const ko = {
  common: {
    searchPlaceholder: 'yyyy-mm으로 검색해주세요.',
    search: '검색',
    reset: '초기화',
    noData: '데이터가 없습니다.',
    player: '플레이어',
    center: '센터',
    enterDeleteReason: '삭제 사유를 입력해주세요.',
    confirmDelete: '{{target}}를 삭제하시겠습니까?',
    delete: '삭제',
    cancel: '취소',
    loginId: '로그인 ID',
    representativeName: '대표자명',
    registeredDate: '등록일',
    country: '국가',
    mobileNumber: '휴대폰 번호',
    firstName: '이름',
    lastName: '성',
    dateOfBirth: '생년월일',
    gender: '성별',
    male: '남자',
    female: '여자',
    nationality: '국적',
    subscriberName: '가입자명',
    status: '상태',
    active: '정상',
    inactive: '비활성화',
    postcode: '우편번호',
    address: '주소',
    selectFile: '파일 선택',
    serverConnectionFailed:
      '서버 연결에 실패하였습니다.\n잠시 후, 다시 시도해 주세요.',
    previous: '이전',
    next: '다음',
    failConnect: '서버 연결에 실패하였습니다.\n잠시후, 다시 시도해 주세요.',
  },
  navbar: {
    playerList: '플레이어 목록',
    partnerList: '파트너 목록',
    r2CenterList: 'R2 센터 목록',
    r2PlannerList: 'R2 플래너 목록',
    signUp: '회원가입',
    playerSignUp: '플레이어 회원가입',
    centreSignUp: '센터 회원가입',
    r2LicenseKeyManagement: 'R2 라이선스 키 관리',
    logout: '로그아웃',
  },
  playerList: {
    title: '플레이어 목록',
    officeName: '오피스 이름',
    office: '오피스(치과명)',
    contact: '연락처',
  },
  playerDetail: {
    clinicNumber: '클리닉 번호',
    officeName: '오피스 이름',
    officeAddress: '오피스 주소',
  },
  deleteAccount: {
    deleteAccount: '계정 삭제',
    notFound: '대상을 찾을 수 없습니다.',
    hasCloudOrderData: '클라우드 관련 주문 데이터가 존재합니다.',
    hasScannerData: '스캐너 관련 데이터가 존재합니다.',
    hasChatData: '채팅 데이터가 존재합니다.',
    hasPingPongOrderData: '핑퐁 주문 관련 데이터가 존재합니다.',
    deleteSuccess: '계정이 정상적으로 삭제되었습니다.',
    deleteFailed: '삭제 중 오류가 발생했습니다.',
    hasPartnerServiceData: '파트너 서비스 관련 데이터가 존재합니다.',
    hasFavouritePlayers: '해당 파트너를 즐겨찾기한 플레이어가 존재합니다.',
    hasPartnerProfileData: '파트너 프로필 관련 데이터가 존재합니다.',
  },
  centerList: {
    title: 'R2 센터 목록',
    centerName: '센터명',
    centerNumber: '센터 번호',
    centerAddress: '센터 주소',
    businessDocument: '비즈니스 서류',
  },
  plannerList: {
    title: 'R2 플래너 목록',
    plannerName: 'R2 플래너명',
    phoneNumber: '전화번호',
    qualificationDocument: '자격 서류',
  },
  signUp: {
    title: '신규회원 등록',
    description: '관리자가 직접 신규 {{type}} 계정을 생성하고 관리합니다.',
    notice:
      '실제 사용 중인 계정 정보로 생성해주세요. 허위 정보 입력 시 서비스 이용에 제한될 수 있습니다.',
    accountActivation: '계정 활성화 설정',
    permission: '부여 권한',
    submit: '신규 가입',
    passwordRule:
      '비밀번호는 영문/숫자/특수문자를 포함한 8자 이상이어야 합니다.',
    passwordMismatch: '비밀번호가 일치하지 않습니다.',
    emailAlreadyExists: '이미 존재하는 이메일입니다.',
    registrationReason: '가입 처리 사유',
    registrationReasonPlaceholder:
      'ex. 000 님의 카카오톡 요청을 통해 관리자 웹에서 생성',
    numberOnly: '숫자만 입력',
  },
  playerSignUp: {
    registerSuccess: '{{name}}님의 신규 Player 등록이 완료되었습니다.',
    contactAndAffiliation: '연락처 및 소속 정보',
    officeName: '오피스 이름',
    officeNamePlaceholder: '소속 오피스명 입력',
    createPlayerAccount: '플레이어 계정 생성',
    loginInformation: '로그인 정보',
    email: '이메일',
    password: '비밀번호',
    passwordPlaceholder: '영문/숫자/특수문자 조합 8자 이상',
    confirmPassword: '비밀번호 확인',
    confirmPasswordPlaceholder: '비밀번호 재입력',
    basicInformation: '기본 인적 사항',
    firstNamePlaceholder: '홍',
    lastNamePlaceholder: '길동',

    selectNationality: '국적 선택',
    detailAddressPlaceholder: '상세 주소 입력',
    clinicNumber: '클리닉 번호',
    centerAddress: '센터 주소',
    officeAddress: '오피스 주소',
  },
  centerSignUp: {
    businessDocumentRequired: '비즈니스 서류는 필수 항목입니다.',
    registerSuccess: '{{name}}님의 신규 Center 등록이 완료되었습니다.',
    maxFileCount: '최대 5개의 파일만 업로드할 수 있습니다.',
    supportedFileTypes: 'JPG, JPEG, PNG, PDF 파일만 업로드할 수 있습니다.',
    maxFileSize: '각 파일은 40MB 이하만 업로드할 수 있습니다.',
    fileUploadFailed: '파일 업로드 중 오류가 발생했습니다.',
    contactAndCenterInformation: '연락처 및 센터 정보',
    representativeNamePlaceholder: '대표자명 입력',
    businessDocument: '비즈니스 서류',
    createCenterAccount: '센터 계정 생성',
    r2CenterName: 'R2 센터명',
    centerNamePlaceholder: '센터명 입력',
    r2CenterPhoneNumber: 'R2 센터 대표번호',
  },
  licenseManagement: {
    title: 'R2 라이선스 키 관리',
    issueAll: '전체 발급',
    totalIssuedLicenseKeys: '누적 발급 라이선스 키',
    status: {
      unregistered: '미등록',
      pending: '미사용 대기중',
      registered: '등록됨',
      activated: '활성화 완료',
      revoked: '폐기됨',
      unavailable: '사용 불가',
    },
    number: '번호',
    licenseKey: '라이선스 키',
    moduleName: '모듈명',
    statusLabel: '상태',
    createdDate: '생성일',
    registeredDate: '등록일',
    revokedDate: '폐기일',
    registeredId: '등록 ID',
    issuer: '발급인',
    issueReason: '발급 사유',
    memo: '메모',
    issueLicenseKey: '라이선스 키 발급',
    enableRevocationMode: '폐기 모드 활성화',
    disableRevocationMode: '폐기 모드 종료',
    issueForm: {
      issuer: '발급인',
      issueReason: '발급 사유 (최대 30자)',
      moduleType: '모듈 종류',
      issueQuantity: '발급 수량 (최대 10개)',
      issue: '발급',
    },
    copyLicenseKey: '라이선스 키 복사',
    close: '닫기',
    memoCell: {
      addMemo: '메모 추가',
      writtenBy: '메모 작성:',
      lockedNotice: '한 번 등록한 메모는 수정할 수 없습니다.',
      close: '닫기',
      placeholder: '메모를 입력하세요',
      writeNotice: '메모는 등록 후 수정할 수 없으니 신중히 작성해주세요.',
      cancel: '취소',
      register: '등록',
    },
    messages: {
      moduleChangeWarning:
        '모듈을 변경하면 발급된 라이선스 키 정보가 초기화 됩니다.\n발급된 라이선스 키 정보는 목록에서 확인할 수 있습니다.\n\n모듈을 변경하시겠습니까?',
      issueReasonRequired: '발급 사유를 작성하세요.',
      issueQuantityRequired: '발급 수량을 입력하세요.',
      issueQuantityLimit: '한번에 최대 10개까지 발급할 수 있습니다.',
      copySuccess: '라이선스 키가 복사 되었습니다.',
      exitIssueConfirm: '라이선스 키 발급을 종료하시겠습니까?',
      issuing: '발급중...',
      issue: '발급',
      revokeConfirm:
        '등록된 라이선스 키를 폐기하시겠습니까?\n폐기한 라이선스 키는 다시 사용할 수 없습니다.\n\n모듈명 : {{module}}\n라이선스 키 : {{licenseKeyId}}\n등록 ID : {{usedByMemberLoginId}}',

      revokeSuccess: '라이선스 키가 폐기 되었습니다.',
      cannotRevoke: '폐기할 수 없는 라이선스 키 입니다.',
      licenseKeyNotFound:
        '존재하지 않는 라이선스 키예요. 목록을 새로고침한 뒤 다시 시도해주세요.',
      memoAlreadyRegistered:
        '이미 메모가 등록된 라이선스 키예요. 등록된 메모는 수정할 수 없어요.',
      memoRequired: '메모 내용을 입력한 뒤 다시 시도해주세요.',
    },
  },
} as const;

export default ko;
